import React, { FC } from "react";
import { Form, Input, Select } from "antd";
import { Col, Row } from "antd";
import { DatePicker } from "antd";

type PatientDetailsProps = {
  form: any;
  disabled: boolean;
};

const { Option } = Select;

const PatientDetails: FC<PatientDetailsProps> = ({ form, disabled }) => {
  const aadharStatusOptions = [
    {
      label: "Patient does not have an Aadhaar Number",
      value: "Patient does not have an Aadhaar Number",
    },
    {
      label: "Patient has an Aadhaar Number",
      value: "Patient has an Aadhaar Number",
    },
    {
      label: "Patient is NDG / J&K / NE State hence exempted",
      value: "Patient is NDG / J&K / NE State hence exempted",
    },
  ];

  const aadharSelectedValue = Form.useWatch(
    ["patientDetails", "aadharStatus"],
    form
  );
  // const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <div>
      {/* <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        PATIENT DETAILS
      </div> */}

      <Form
        form={form}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%" }}
      >
        <Row gutter={[16, 16]} className="form-row">
          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="PATIENT NAME" name="fullName">
              <Input disabled={true} placeholder="Enter patient Name" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="AGE" name="age">
              <Input disabled={true} placeholder="Enter age" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="ADDRESS" name="address">
              <Input disabled={true} placeholder="Enter address" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="PHONE NUMBER" name="primaryMobile">
              <Input disabled={true} placeholder="Enter phone Number" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="Referral Type" name="referralType">
              <Input disabled={true} placeholder="Enter referral Type" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="PATIENT TYPE" name="patientType">
              <Input disabled={true} placeholder="Enter patient Type" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="REGION" name="region">
              <Input disabled={true} placeholder="Enter region" />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="FINANCIAL YEAR"
              name="financialYear"
            >
              <Input disabled={true} 
              placeholder="Enter financialYear" />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="Name Of ESM" name="nameOfESM">
              <Input disabled={true} placeholder="Enter name Of ESM" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="Card TYPE" name="cardType">
              <Input disabled={true} placeholder="Enter card Type" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="Category" name="category">
              <Input disabled={true} placeholder="Enter category" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="WHITE CARD APPLICABLE" name="whitwCardApplicable">
              <Input disabled={true} placeholder="Enter white Card Applicable" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="RANK" name="rank">
              <Input disabled={true} placeholder="Enter rank" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="GENDER" name="gender">
              <Input disabled={true} placeholder="Enter gender" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="RELATION WITH CARD HOLDER"
              name="relationWithCardHolder"
            >
              <Input
                disabled={true}
                placeholder="Enter relation With Card Holder "
              />
            </Form.Item>
          </Col> */}

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="AADHAR CARD STATUS"
              name={["patientDetails", "aadharStatus"]}
              rules={[{ required: true, message: "Aadhar Card Status is required" }]}
            >
              {/* <Input
                disabled={disabled}
                placeholder="Enter Aadhar Card Status"
              /> */}
              <Select
                disabled={disabled}
                placeholder="Select Aadhar Card Status"
                optionRender={(option) => (
                  <div
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      maxWidth: "100%",
                    }}
                  >
                    {option.label}
                  </div>
                )}
                allowClear
              >
                {aadharStatusOptions?.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="AADHAR CARD NUMBER"
              name={["patientDetails", "aadharNumber"]}
              rules={[
                {
                  required: aadharSelectedValue === "Patient has an Aadhaar Number" ? true : false,
                  message: "Aadhar Card Number is required",
                },
                {
                  pattern: /^[2-9]{1}[0-9]{11}$/,
                  message: "Enter a valid 12-digit Aadhaar number",
                },
              ]}
            >
              <Input
                disabled={disabled}
                placeholder="Enter Aadhar Card Number"
                type="text"
                maxLength={12}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  form.setFieldsValue({
                    patientDetails: {
                      ...form.getFieldValue("patientDetails"),
                      aadharNumber: value,
                    },
                  });
                }}
              />
            </Form.Item>
          </Col>

          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="CITY" name="city">
              <Input disabled={true} placeholder="Enter city " />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="STATE" name="state">
              <Input disabled={true} placeholder="Enter state " />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="PINCODE" name="pincode">
              <Input disabled={true} placeholder="Enter pincode" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item label="EMAIL" name="email">
              <Input disabled={true} placeholder="Enter email " />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="PHONE"
              name="phoneNumber"
            >
              <Input disabled={true} 
              placeholder="Enter phoneNumber " />
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </div>
  );
};

export default PatientDetails;
